import { GetConfigCmSheetsStatsResponse } from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsCmSheets = {
  async getStats(): Promise<GetConfigCmSheetsStatsResponse> {
    const response = await httpClient.get<GetConfigCmSheetsStatsResponse>(
      "v1/config/cm-sheets/stats",
    );
    return response;
  },
  async archiveAll(): Promise<void> {
    await httpClient.post("v1/config/cm-sheets/archiveAll");
  },
  async solicitAll(): Promise<void> {
    await httpClient.post("v1/config/cm-sheets/solicitAll");
  },
};

export default ConfigurationsCmSheets;
